// Parametri del periodo condivisi con il report (stessa query string)
export const filtersFromQuery = query => {
	const now = new Date();
	return {
		period: query.period || 'month',
		year: +query.year || now.getFullYear(),
		month: +query.month || now.getMonth() + 1,
		quarter: +query.quarter || Math.floor(now.getMonth() / 3) + 1,
		from: query.from || '',
		to: query.to || '',
		compare: query.compare || 'prev',
		platform: query.platform || '',
	};
};

export const filtersToParams = f => {
	const params = { period: f.period, compare: f.compare };
	if (f.period === 'custom') {
		params.from = f.from;
		params.to = f.to;
	} else {
		params.year = f.year;
		if (f.period === 'month') params.month = f.month;
		if (f.period === 'quarter') params.quarter = f.quarter;
	}
	if (f.platform) params.platform = f.platform;
	return params;
};
